<carousel>
  <slide>
    <div class="basicrow">
      <div class="main-grid">
        <div class="boxes">
          <div class="box-title">
            Ventas y Solicitudes de Servicio
          </div>
          <div class="box-img">
            <img class="style-img" src="../../../../assets/images/venta (1).jpg">
          </div>
          <ul>
            <li>
              <a href="/assets/DocumentsLink/CLARO WSR.XLSX" download="CLARO WSR" class="box-link">Claro WSR</a>
            </li>
            <li>
              <a href="/assets/DocumentsLink/IP Request Form_Cust.doc" download="IP Request Form_Cust" class="box-link">IP Request form Cust</a>    
            </li>
            <li>
              <a href="/assets/DocumentsLink/RESELLER SERVICE REQUEST.XLSX" download="RESELLER SERVICE REQUEST" class="box-link">Reseller Service Request</a>    
            </li>
            <!-- <li>
              <a href="/assets/DocumentsLink/TOWER SPACE LEASE REQUEST FORM.XLSX" download="TOWER SPACE LEASE REQUEST FORM" class="box-link">Tower Space Lease Form</a>    
            </li> -->
          </ul>
          <div class="box-btn" style="display: none;">
            <a (click)="navNews()" href="https://www.claropr.com/negocios/" target="_blank" class="btns bgray vcenter">
              <span class="tabcell">
                Ver detalles&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
              </span>
            </a>
          </div>
        </div>
        <div class="boxes">
          <div class="box-title">
            Servicio al Cliente
          </div>
          <div class="box-img">
            <img class="style-img" src="/assets/images/venta (4).jpg">
          </div>
          <ul>
            <li>
              <a href="/assets/DocumentsLink/Directorio Departamental.pdf" target="_blank" class="box-link">Directorio Departamental</a>
            </li>
          </ul>
          <div class="box-btn" style="display: none;">
            <a (click)="navNews()" href="https://www.clarocloudpr.com/portal/pr/cld/" target="_blank"
              class="btns bgray vcenter">
              <span class="tabcell">
                Ver detalles&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
              </span>
            </a>
          </div>
        </div>
        <div class="boxes">
          <div class="box-title">
            Reclamaciones de Factura
          </div>
          <div class="box-img">
            <img class="style-img" src="/assets/images/venta (3).jpg">
          </div>
          <ul>
            <li>
              <a href="/assets/DocumentsLink/Dispute Claim Form.xlsx" download="Dispute Claim Form" class="box-link">Dispute Claim Form</a>
            </li>
            <li>
              <a href="/assets/DocumentsLink/Dispute Claim Form_reference sheet.xlsx" download="Dispute Claim Form_reference sheet" class="box-link">Dispute Claim From Reference Sheet</a>    
            </li>
          </ul>
          <div class="box-btn" style="display: none;">
            <a (click)="navNews()" href="https://claropr.com/negocios/soluciones/soluciones-fijas/" target="_blank"
              class="btns bgray vcenter">
              <span class="tabcell">
                Ver detalles&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
              </span>
            </a>
          </div>
        </div>
        <div class="boxes">
          <div class="box-title">
            Escalation List 
          </div>
          <div class="box-img">
            <img class="style-img" src="/assets/images/venta (2).jpg">
          </div>
          <ul>
            <li>
              <a href="/assets/DocumentsLink/Wholesale_Escalation_Carriers_Wholesale_Strategic_Sales.pdf" target="_black" class="box-link">Wholesale Escalation List</a>
            </li>
          </ul>
          <div class="box-btn" style="display: none;">
            <a (click)="navNews()"
              href="https://www.claropr.com/negocios/soluciones/soluciones-fijas/television-negocios/" target="_blank"
              class="btns bgray vcenter">
              <span class="tabcell">
                Ver detalles&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </slide>
</carousel>